<div class="">
  @if (currentNotification()) {
    <div class=" recipient-form">
      <div class="page-header">
        <div class="columns">
          <div class="column is-3-tablet is-4-desktop is-4-widescreen is-4-fullhd  ">
            <h3>Recipients for
              @if (currentNotification().notificationType) {
                <span>{{currentNotification().notificationType.value}}</span>
              }
              notification
            </h3>
          </div>
          <div class="column">
            <div class="columns is-paddingless">
              <div class="column is-paddingless has-add-buttons">
                <div class=" top-add-buttons is-pulled-right has-add-buttons" [ngClass]="{'is-hidden' : !showAddButtonDiv }">
                  <button [disabled]="isEditingDisabled()" class="button is-radiusless is-add-role" (click)="addRole()">+ role</button>
                  <button [disabled]="isGroupNav || !isEditable" class="button is-radiusless is-add-person" (click)="addPerson()">+ person </button>
                  <button [disabled] ="isEditingDisabled()" class="button is-radiusless is-add-shared" (click)="addSharedEmail()">+ shared email </button>
                  <button [disabled] ="isEditingDisabled()" class="button is-radiusless is-add-person-type" (click)="addPersonType()">+ reg person type </button>
                </div>
              </div>
              <div class="column is-paddingless  has-edit-bar is-one-half-tablet is-one-half-desktop is-one-half-widescreen is-5-fullhd ">
                <mc-edit-bar [selectionCount]="selectedIds.length" [actionSetting]="actionSetting" (selectedActionEvent)="selectedEditAction($event)">
                </mc-edit-bar>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="columns"></div>
      <div class="recipient-list">
        <table class="table is-fullwidth " role="table">
          <thead>
            <tr role="row">
              <th class="has-text-centered">
                <span>
                </span>
              </th>
              @for (column of columns; track column) {
                @if (column.display) {
                  <th class="table-header"
                    [mcTableSorting]="config" [column]="column" title="{{column.title}}"
                    (sortChanged)="onChangeTable($event)"
                    ngClass="{{column.className || ''}}">
                    <span> {{column.title}}</span>
                    @if (config && rows.length > 0 && column.sort != undefined) {
                      <span class="sort  is-text-centered">
                        @if (column.sort === '') {
                          <span>
                            <i class="fas fa-sort"></i>
                          </span>
                        }
                        @if (column.sort === 'desc') {
                          <span>
                            <i class="fas fa-sort-down"></i>
                          </span>
                        }
                        @if (column.sort === 'asc') {
                          <span>
                            <i class="fas fa-sort-up"></i>
                          </span>
                        }
                      </span>
                    }
                  </th>
                }
              }
            </tr>
          </thead>
          <tbody>
            @if (showFilterRow) {
              <tr>
                @for (column of columns; track column; let i = $index) {
                  <td>
                    @if (column.filtering) {
                      <input placeholder="{{column.filtering.placeholder}}" [mcTableFiltering]="column.filtering" class="form-control"
                        (tableChanged)="onChangeTable(config)" />
                    }
                  </td>
                }
              </tr>
            }
            @for (row  of rows; track row ; let rowIdx = $index) {
              <tr role="row"
                [ngClass]="{'is-selected' : isRowSelected(row)}">
                <td class="has-text-centered">
                  <a (click)="cellClick($event, row, 'select')"[ngClass] ="{'is-disabled-link': isGroupNav || !isEditable}" >
                    <span class="icon is-small">
                      @if (!isRowSelected(row)) {
                        <span>
                          <i class="far fa-square"></i>
                        </span>
                      }
                      @if (isRowSelected(row)) {
                        <span>
                          <i class="far fa-check-square"></i>
                        </span>
                      }
                    </span>
                  </a>
                </td>
                <td role="cell">
                  @if (isRoleType(row.notificationDistributionType)) {
                    <div>
                      <select
                        [(ngModel)]="row.role" [compareWith]="compareRoleFn"
                        (change)="roleUpdated()" [disabled] ="!isEditMode(row)">
                        <option [ngValue]="newNotificationCode" selected>-- Select --</option>
                        @for (role of roles; track role) {
                          <option [ngValue]="role">
                            {{role.desc}}
                          </option>
                        }
                      </select>
                    </div>
                  }
                  @if (isSharedEmailType(row.notificationDistributionType)) {
                    <div>
                      <select [(ngModel)]="row.sharedEmail" [compareWith]="compareRoleFn" [disabled] ="!isEditMode(row)">
                        <option [ngValue]="undefined" selected>-- Select --</option>
                        @for (eachItem of sharedEmails; track eachItem) {
                          <option [ngValue]="eachItem">
                            {{eachItem.desc}}
                          </option>
                        }
                      </select>
                    </div>
                  }
                  @if (isPersonType(row.notificationDistributionType)) {
                    <div>
                      <select [(ngModel)]="row.personType" [compareWith]="compareRoleFn" (change)="personTypeUpdated()" [disabled] ="!isEditMode(row)">
                        <option [ngValue]="newNotificationCode" selected>-- Select --</option>
                        @for (personType of personTypes; track personType) {
                          <option [ngValue]="personType">
                            {{personType.desc}}
                          </option>
                        }
                      </select>
                    </div>
                  }
                  @if (isIndividualType(row.notificationDistributionType)) {
                    <div >
                      <span>Individual</span>
                    </div>
                  }
                </td>
                <td role="cell">
                  @if (isRoleType(row.notificationDistributionType) || isSharedEmailType(row.notificationDistributionType) || isPersonType(row.notificationDistributionType) ) {
                    <div>
                      <span>N/A</span>
                    </div>
                  }
                  @if (isIndividualType(row.notificationDistributionType)) {
                    <div>
                      <div class="field has-addons">
                        <div class="control">
                          <input class="input is-small" type="text" disabled="disabled"
                            [value]="getPersonName(row)" >
                          </div>
                          <div class="control">
                            <button class="button  is-small" [disabled]="!isEditMode(row)"
                      [ngClass]="{'is-primary' : !isRowSelected(row), 
                      'is-custom-save' : isRowSelected(row)}" (click)="editIndividual(row)">
                              Edit
                            </button>
                          </div>
                        </div>
                        <!-- <input type="text" name="person-{{index}}" [(ngModel)]="row.individual.firstName" [disabled]="!isEditMode(row)"> -->
                      </div>
                    }
                  </td>
                  <td role="cell">
                    @if (isRoleType(row.notificationDistributionType) || isPersonType(row.notificationDistributionType)) {
                      <div>
                        <span>N/A</span>
                      </div>
                    }
                    @if (isSharedEmailType(row.notificationDistributionType)) {
                      <div>
                        @if (row.sharedEmail) {
                          <span>{{row.sharedEmail.value}} </span>
                        }
                      </div>
                    }
                    @if (isIndividualType(row.notificationDistributionType)) {
                      <div>
                        <input type="text" name="email" disabled="disabled"
                          [value]="row.individual.email" >
                        </div>
                      }
                    </td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        </div>
      }

      <div class="modal person-modal" [ngClass]="{'is-active': showModal}">
        <div class="modal-background"></div>
        <div class="modal-card">
          <header class="modal-card-head">
            <p class="modal-card-title">Person Selection</p>
          </header>
          <section class="modal-card-body">
            Provide one or more of the following criteria
            <div class="has-search-criteria">
              <div class="field is-horizontal is-grouped">
                <div class="field-label  ">
                  <label class="">First&nbsp;Name: </label>
                </div>
                <div class="field-body">
                  <div class="field">
                    <div class="control">
                      <input class="input is-small " type="text" [(ngModel)]="searchCriteriaPerson.firstName">
                    </div>
                  </div>
                </div>
                <div class="field-label  ">
                  <label class=" ">&nbsp;&nbsp;Last&nbsp;Name: </label>
                </div>
                <div class="field-body">
                  <div class="field  has-addons">
                    <div class="control">
                      <input class="input is-small " type="text" [(ngModel)]="searchCriteriaPerson.lastName">
                    </div>
                    <p class="control ">
                      <button class="button is-primary is-small" [disabled]="!isValidSearchCriteria()" (click)="findPersonMatches()">
                        Search
                      </button>
                    </p>
                  </div>
                </div>
                <!-- <div class="field-label is-small">
                <label class=" ">Email: </label>
              </div>
              <div class="field-body">
                <div class="field  has-addons">
                  <div class="control">
                    <input class="input is-small " type="text"
                      [(ngModel)]="searchCriteriaPerson.email">
                    </div>
                    <p class="control ">
                      <a class="button is-primary is-small">
                        Search
                      </a>
                    </p>
                  </div>
                </div> -->
              </div>
            </div>
            @if (persons.length > 0) {
              <div>
                <div class="has-fixed-table-header form-table-container">
                  <table class="is-scroll-table header table is-striped is-fullwidth "
                    role="grid">
                    <thead>
                      <tr>
                        <!-- <th>First Name</th>
                        <th>Last Name</th>
                        <th>Email</th> -->
                        @for (column of personColumns; track column) {
                          @if (column.display) {
                            <th class="table-header "
                              [mcTableSorting]="personConfig" [column]="column" title="{{column.title}}"
                              (sortChanged)="onChangePersonTable($event)"
                              ngClass="{{column.className || ''}}">
                              <span> {{column.title}}</span>
                              @if (personRows.length > 0 && personConfig && column.sort != undefined) {
                                <span class="sort  is-text-centered">
                                  @if (column.sort === '') {
                                    <span>
                                      <i class="fas fa-sort"></i>
                                    </span>
                                  }
                                  @if (column.sort === 'desc') {
                                    <span>
                                      <i class="fas fa-sort-down"></i>
                                    </span>
                                  }
                                  @if (column.sort === 'asc') {
                                    <span>
                                      <i class="fas fa-sort-up"></i>
                                    </span>
                                  }
                                </span>
                              }
                            </th>
                          }
                        }
                      </tr>
                    </thead>
                    <tbody>
                      @if (showPersonFilterRow) {
                        <tr>
                          @for (column of personColumns; track column) {
                            @if (column.display) {
                              <td >
                                @if (column.filtering) {
                                  <input placeholder="{{column.filtering.placeholder}}"
                                    [mcTableFiltering]="column.filtering"
                                    class="form-control filter-width"
                                    (tableChanged)="onChangePersonTable(personConfig)" />
                                }
                              </td>
                            }
                          }
                        </tr>
                      }
                      @for (row of personRows; track row) {
                        <tr (click)="selectPerson(row)"
                          [ngClass]="{'is-selected': isPersonSelected(row)}"
                          id="{{row.personUUID}}" >
                          <td class="has-fixed-cell-width">
                            {{row.firstName}}
                          </td>
                          <td class="has-fixed-cell-width">
                            {{row.lastName}}
                          </td>
                          <td>
                            {{row.email}}
                          </td>
                        </tr>
                      }
                    </tbody>
                  </table>
                </div>
              </div>
            }
          </section>
          <footer class="modal-card-foot">
            <button class="button is-primary is-radiusless"
              [disabled]="selectedPerson==null"
            (click)="setSelectedPerson()">Select</button>
            <button class="button is-radiusless"
            (click)="cancelSelectedPerson()">Cancel</button>
          </footer>
        </div>
      </div>

    </div>
